"use client"

import * as React from "react"

import { cn } from "@productlane/lib/src/browser"

import * as ScrollAreaPrimitive from "./reversed-scrollarea"

const ScrollArea = React.forwardRef<
	React.ElementRef<typeof ScrollAreaPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.Root>
	// Scrollbars show while scrolling and fade out after; hovering a list never
	// summons one.
>(({ className, children, type = "scroll", ...props }, ref) => (
	<ScrollAreaPrimitive.Root
		ref={ref}
		className={cn("relative h-full overflow-hidden", className)}
		type={type}
		{...props}
	>
		{children}
		<ScrollBar />
		<ScrollAreaPrimitive.Corner />
	</ScrollAreaPrimitive.Root>
))

const ScrollViewport = React.forwardRef<
	React.ElementRef<typeof ScrollAreaPrimitive.Viewport>,
	React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.Viewport>
>(({ className, children, ...props }, ref) => (
	<ScrollAreaPrimitive.Viewport
		style={{}}
		className={cn("h-full w-full rounded-[inherit] [&>div]:!block", className)}
		ref={ref}
		{...props}
	>
		{children}
	</ScrollAreaPrimitive.Viewport>
))

const ScrollBar = React.forwardRef<
	React.ElementRef<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>,
	React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>
>(({ className, orientation = "vertical", ...props }, ref) => (
	<ScrollAreaPrimitive.ScrollAreaScrollbar
		ref={ref}
		orientation={orientation}
		className={cn(
			"flex touch-none select-none transition-colors",
			orientation === "vertical" &&
				"h-full w-2.5 border-l border-l-transparent p-[1px]",
			orientation === "horizontal" &&
				"h-2.5 flex-col border-t border-t-transparent p-[1px]",
			className,
		)}
		{...props}
	>
		<ScrollAreaPrimitive.ScrollAreaThumb className="relative z-10 flex-1 rounded-full bg-gray-200 dark:bg-gray-700" />
	</ScrollAreaPrimitive.ScrollAreaScrollbar>
))

export { ScrollArea, ScrollBar, ScrollViewport }
